import React from "react";

export function getPasswordRules(password = "") {
  return [
    { label: "At least 8 characters", valid: password.length >= 8 },
    { label: "Contains uppercase letter", valid: /[A-Z]/.test(password) },
    { label: "Contains lowercase letter", valid: /[a-z]/.test(password) },
    { label: "Contains a number", valid: /[0-9]/.test(password) },
    { label: "Contains special character (!@#$%^&*)", valid: /[^A-Za-z0-9]/.test(password) },
  ];
}

export default function PasswordStrength({ password = "" }) {
  if (!password) return null;

  const rules = getPasswordRules(password);
  const passedCount = rules.filter((r) => r.valid).length;

  let strengthLabel = "Weak";
  let barColor = "#dc3545"; // Red
  let percentage = (passedCount / rules.length) * 100;

  if (passedCount >= 5) {
    strengthLabel = "Strong";
    barColor = "#198754"; // Green
  } else if (passedCount >= 3) {
    strengthLabel = "Medium";
    barColor = "#ffc107"; // Yellow
  }

  return (
    <div style={{ marginTop: "12px", marginBottom: "16px" }}>
      {/* Strength Bar */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "6px",
          fontSize: "13px",
          fontWeight: "600",
          color: "#495057",
        }}
      >
        <span>Password Strength:</span>
        <span style={{ color: barColor }}>{strengthLabel}</span>
      </div>
      <div
        style={{
          height: "6px",
          width: "100%",
          backgroundColor: "#e9ecef",
          borderRadius: "3px",
          overflow: "hidden",
          marginBottom: "12px",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${percentage}%`,
            backgroundColor: barColor,
            transition: "width 0.3s ease, background-color 0.3s ease",
          }}
        />
      </div>

      {/* Rules Checklist */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "6px", fontSize: "12px" }}>
        {rules.map((rule, idx) => (
          <div key={idx} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "50%",
                backgroundColor: rule.valid ? "#198754" : "#ced4da",
                color: "#fff",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "10px",
                fontWeight: "bold",
              }}
            >
              {rule.valid ? "✓" : "•"}
            </span>
            <span style={{ color: rule.valid ? "#198754" : "#6c757d" }}>{rule.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
